import {BaseProfilePage} from './profileBase';
import {ProfilePageHeader} from '../components/ProfilePageHeader';

import {Component} from 'inferno'; // eslint-disable-line @typescript-eslint/no-unused-vars

import {Metadata} from '../../common/metadata';
import {Link} from '../../common/components';
import {HTTP404Page} from '../../common/components/http404';
import {getArticleLDJSON, isValidUsername, safelySerializeJSON, tryDecodeURI} from '../../common/util';

import {maybeReturnComponent, subscribe, transformProps} from '../../../replete';


@subscribe({
    auth: ['api.auth'],
})
@transformProps((props: jsx.Props, context: jsx.AppGlobals) => {
    props.authedUsername = context.authService.getUsername();

    return props;
})
@transformProps((props: jsx.Props, context: jsx.AppGlobals) => {
    props.username = tryDecodeURI(props.match.params.username);
    props.mediatype = props.match.params.mediatype;
    props.ownsProfile = context.authService.ownsProfile(props.username);

    return props;
})
@maybeReturnComponent((props: jsx.Props) => {
    if (!isValidUsername(props.username)) {
        return HTTP404Page;
    }
})
@subscribe({
    pageState: ['ui.BaseProfilePage.*', 'username'],
    isMobile: ['ui.isMobile'],
})
@transformProps((props: jsx.Props, context: jsx.AppGlobals) => {
    props.section = props.pageState.section;

    if (props.ownsProfile && props.section !== BaseProfilePage.FAVORITES) {
        context.store.call(
            'api.gifs.searchByUsername.*',
            [props.username, props.section, props.ownsProfile],
            'delete',
        );
        context.store.call(
            'api.memes.searchByUsername.*',
            [props.username, props.section, props.ownsProfile],
            'delete',
        );
        context.store.call(
            'api.stickers.searchByUsername.*',
            [props.username, props.section, props.ownsProfile],
            'delete',
        );
    }

    return props;
})
@subscribe({
    profile: ['api.profiles.*', 'username', 'authedUsername'],
    gifs: ['api.gifs.searchByUsername.*', 'username', 'section', 'ownsProfile'],
    memes: ['api.memes.searchByUsername.*', 'username', 'section', 'ownsProfile'],
    stickers: ['api.stickers.searchByUsername.*', 'username', 'section', 'ownsProfile'],
})
export class UserProfilePage extends BaseProfilePage {
    renderProfilePageView(
        ownsProfile: boolean, memeList: api.Post[], stickerList: api.Post[],
        gifList: api.Post[]): Element {
        const gettextSub = this.context.gtService.gettextSub;
        const localizeUrlPath = this.context.gtService.localizeUrlPath;
        const noUploads = this.props.gifs.noMore && !gifList.length &&
            this.props.stickers.noMore && !stickerList.length &&
            this.props.memes.noMore && !memeList.length;
        return <div className="content">
            { ownsProfile === true &&
                <div className="switch-view-link">
                    <a onClick={() => {
                        this.setSection(BaseProfilePage.FAVORITES);
                    }}>
                        {gettextSub('View Favorites')}
                    </a>
                </div>
            }
            { memeList.length > 0 && this.renderMemeListSection(memeList)}
            { stickerList.length > 0 &&
                this.renderStickerListSection(stickerList)}
            { gifList.length > 0 && this.renderGifListSection(gifList) }
            { noUploads && ownsProfile === true &&
                <div className="no-gifs">
                    <img className="img1" src="https://media1.tenor.com/images/ac232c5dc7777b2a71dbec2b33aabc48/tenor.gif?itemid=4355705" width="193" height="103"/>
                    <img className="img2" src="https://media1.tenor.com/images/ea0335a92ad2f327d79a7435b3352378/tenor.gif?itemid=5174159" width="173" height="105"/>
                    <img className="img3" src="https://media1.tenor.com/images/7ae535f039842e4e91c4e394e5f486f6/tenor.gif?itemid=4968320" width="159" height="130"/>
                    <h2>{gettextSub('Upload your favorite GIFs!')}</h2>
                    <p>{gettextSub('Upload GIFs and you’ll get notifications when people share or favorite them')}</p>
                    <Link to={localizeUrlPath('/gif-maker?utm_source=empty-profile&utm_medium=internal&utm_campaign=gif-maker-entrypoints')} className="button">
                        {gettextSub('Upload')}
                    </Link>
                </div>
            }
            { noUploads && ownsProfile === false &&
                <div className="no-gifs">
                    <img className="img1" src="https://media1.tenor.com/images/566372134dfaf5631e2914a8161a4cc5/tenor.gif?itemid=5173996" width="193" height="103"/>
                    <img className="img2" src="https://media1.tenor.com/images/b3a4ffcad4739f86911550d0d5ee7d24/tenor.gif?itemid=5578688" width="173" height="105"/>
                    <img className="img3" src="https://media1.tenor.com/images/1d66e7ff090092e8f3d2ed24db4c8fc8/tenor.gif?itemid=5337071" width="159" height="130"/>
                    <h2>{gettextSub('{username} hasn’t uploaded any GIFs!', {username: this.props.username})}</h2>
                </div>
            }
        </div>;
    }
    renderPage() {
        if (this.props.profile.pending) {
            return <div></div>;
        }
        this.debug('renderPage', 'auth', this.props.auth, this.props.ownsProfile);

        const [gifList, memeList, stickerList] = this.prepareItemLists();

        let articleLDJSON = {};
        // we don't want to use unprocessed GIFs
        if (this.props.gifs.results.length) {
            articleLDJSON = getArticleLDJSON(this, this.props.gifs.results[0]);
        }
        this.noindex = true;

        const {isMobile, section, mediatype, ownsProfile} = this.props;
        this.profilePageView = section === BaseProfilePage.PROFILE &&
            !mediatype;
        this.favoritesPageView = section === BaseProfilePage.FAVORITES &&
            !mediatype;
        this.memePageView = mediatype === BaseProfilePage.MEMES;
        this.stickerPageView = mediatype === BaseProfilePage.STICKERS;

        return (
            <div>
                <Metadata page={this}>
                    <script type="application/ld+json" dangerouslySetInnerHTML={{__html: safelySerializeJSON(articleLDJSON)}}/>
                </Metadata>
                <div className={`ProfilePage page${ownsProfile === true ? ' self' : ''}`}>
                    <ProfilePageHeader
                        profile={this.props.profile.user}
                        fullProfile={this.props.profile}
                    />
                    <div className="container">
                        { this.profilePageView &&
                            this.renderProfilePageView(
                                ownsProfile, memeList, stickerList, gifList) }
                        { this.favoritesPageView &&
                           this.renderFavoritesPageView(ownsProfile, gifList) }
                        { this.memePageView &&
                            this.renderMemePageView(
                                isMobile, memeList, gifList) }
                        { this.stickerPageView &&
                            this.renderStickerPageView(
                                isMobile, stickerList, gifList) }
                    </div>
                </div>
            </div>
        );
    }
}
